import { ReactNode, useEffect } from 'react';
import { FleetManagementState } from './FleetManagementState.ts';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { useSubscription } from '@meraki-internal/state';

export const EnsureFleetLoaded: React.FC<{children: ReactNode}> = ({ children }) => {
    const fleetState = useInstance(FleetManagementState);
    useSubscription(() => fleetState);

    useEffect(() => {
        fleetState.ensureLoaded();
    }, [fleetState]);

    if (fleetState.loaded) {
        return (
            <>{children}</>
        );
    } else {
        return null;
    }
};
